import { apiGet, apiPost, apiPut, apiDelete } from "../../api/client";
import { ICustomer } from "../../types";

/**
 * REST client for the `customers` resource. Replaces direct Firestore access so
 * customer data is read and written exclusively through the API. Returns plain
 * `ICustomer` payloads; callers (hooks / models) wrap them in the `Customer`
 * model where instance semantics are required.
 */

const CUSTOMERS_PATH = "/api/customers/";

/** Full customer list for a workspace (no pagination — current default). */
export const listCustomers = async (
  token: string,
  workspaceId: string,
): Promise<ICustomer[]> => {
  const envelope = await apiGet(token, CUSTOMERS_PATH, workspaceId);
  return (envelope?.data as ICustomer[]) ?? [];
};

export const getCustomer = async (
  token: string,
  workspaceId: string,
  customerId: string,
): Promise<ICustomer> => {
  const envelope = await apiGet(
    token,
    `${CUSTOMERS_PATH}${customerId}`,
    workspaceId,
  );
  return envelope?.data as ICustomer;
};

/** Serialized customer payload sent as a JSON request body (e.g. `Customer.data()`). */
type CustomerPayload = Record<string, unknown>;

export const createCustomer = async (
  token: string,
  workspaceId: string,
  customer: CustomerPayload,
): Promise<ICustomer> => {
  const envelope = await apiPost(token, CUSTOMERS_PATH, customer, workspaceId);
  return envelope?.data as ICustomer;
};

export const updateCustomer = async (
  token: string,
  workspaceId: string,
  customerId: string,
  customer: CustomerPayload,
): Promise<ICustomer> => {
  const envelope = await apiPut(
    token,
    `${CUSTOMERS_PATH}${customerId}`,
    customer,
    workspaceId,
  );
  return envelope?.data as ICustomer;
};

export const deleteCustomer = async (
  token: string,
  workspaceId: string,
  customerId: string,
): Promise<void> => {
  await apiDelete(token, `${CUSTOMERS_PATH}${customerId}`, workspaceId);
};
